import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function PathTracker() {
    const router = useRouter();
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const { pathname = '' } = window.location;
            const path = sessionStorage.getItem('path_tracker');
            const { curPath = '' } = path ? JSON.parse(path) : {};
            if (curPath !== pathname) {
                sessionStorage.setItem('path_tracker', JSON.stringify({ prevPath: curPath, curPath: pathname }));
            }
        }
    }, [router]);
    return null;
}
